module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elStartplayingCopy_53395.635224c8.jpg";